module.exports = __webpack_public_path__ + "img/tool-appset.5077832.webp";